import Cookies from 'js-cookie'

import { reset } from '@/lib/analytics'
import { COOKIE_KEYS, LOGOUT_INTENT_FORCED_RESET } from '@/lib/configs/auth-config'
import store from '@/lib/configs/store-config'
import { authAtom, clearAuthState } from '@/state/auth'

export const AUTH_REDIRECT_TO_LOGIN_EVENT = 'orderx:auth-redirect-to-login'

export function requestLoginRedirect() {
  if (typeof window === 'undefined') return
  ;(window as Window & { __isForcedLogout?: boolean }).__isForcedLogout = true

  // Every caller funnels through here specifically so this clear can't be
  // forgotten again — it used to live only in service-util.ts's own
  // auth_rejected branch, and the connection-recovery probe (see
  // use-connection-recovery.ts) called this function directly on a rejected
  // token without ever touching the atom/cookie. That left stale
  // user/accessToken evidence in the AUTH_STATE cookie, which
  // hasRecoverableSessionEvidence() then read back as "still logged in" on
  // the very next mount — triggering another doomed refresh attempt, another
  // rejection, another uncleared redirect — a genuine infinite reload loop
  // on /login. Clearing it here, unconditionally, before anything else,
  // closes that gap for every current and future caller.
  store.set(authAtom, clearAuthState())

  // Forced logouts don't all clear auth state before navigating, so plant the
  // same logout-intent cookie logout() uses — it's what tells useAuth's
  // /login cleanup effect this arrival is a real logout and not a
  // just-logged-in user still rendering /login. The value records that the
  // analytics reset already happened here, so the cleanup effect must not run a
  // second one (every reset() mints a new anonymous distinct id).
  void reset()
  Cookies.set(COOKIE_KEYS.AUTH_LOGOUT_INTENT, LOGOUT_INTENT_FORCED_RESET, {
    expires: 1 / (24 * 60),
    sameSite: 'lax',
    path: '/',
  })

  const event = new CustomEvent(AUTH_REDIRECT_TO_LOGIN_EVENT, {
    cancelable: true,
  })

  const wasNotHandled = window.dispatchEvent(event)
  if (wasNotHandled) {
    window.location.replace('/login')
  }
}
